export default {
  updateCommentsNum(count = 0) {
    this.totalCount = count
  },
  updateCommentsStatus(status) {
    this.commentsStatus = status
  },
  // 设置 用户权限
  setUserAuthority(obj) {
    this.userAuthority = obj
  },

  // 设置 评论列表
  setComment(obj) {
    this.comments = obj.comments || []
    this.remainCount = obj.remainCount || 0
    this.totalCount = obj.totalCount || 0
  },

  // 更新 评论列表
  refreashComment(obj) {
    const comments = obj.comments || []
    this.comments.push(...comments)
    this.remainCount = obj.remainCount || 0
    this.totalCount = obj.totalCount || 0
  },

  updateCommentsList(data) {
    this.comments.unshift(data)
    this.totalCount += 1
  },

  // 更新new message状态
  updateNewMessage(bool) {
    this.hasNewMessage = bool
  },

  // 长按开启引用内容评论
  updateQuoteData(quote) {
    this.quoteData = quote
  }
}
